import { useState, useEffect, useRef, useCallback } from 'react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Per-user saved answers for every Fast Brain sheet (auto-saves ~0.8s after typing stops)
export default function useFastBrainAnswers(userId) {
  const [answers, setAnswers] = useState({});
  const [status, setStatus] = useState({ sheetId: null, state: 'idle' }); // state: idle | saving | saved | error
  const timers = useRef({});

  useEffect(() => {
    if (!userId) return;
    fetch(`${API}/fast-brain/answers?user_id=${encodeURIComponent(userId)}`)
      .then((r) => (r.ok ? r.json() : { answers: {} }))
      .then((d) => setAnswers(Object.fromEntries(Object.entries(d.answers || {}).map(([k, v]) => [k, v.data]))))
      .catch(() => {});
  }, [userId]);

  const update = useCallback((sheetId, data) => {
    setAnswers((prev) => ({ ...prev, [sheetId]: data }));
    setStatus({ sheetId, state: 'saving' });
    clearTimeout(timers.current[sheetId]);
    timers.current[sheetId] = setTimeout(async () => {
      try {
        const res = await fetch(`${API}/fast-brain/answers/${sheetId}`, {
          method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ user_id: userId, data }),
        });
        setStatus({ sheetId, state: res.ok ? 'saved' : 'error' });
      } catch { setStatus({ sheetId, state: 'error' }); }
    }, 800);
  }, [userId]);

  return { answers, update, status };
}
